import React from "react";
import Hero from "./sections/Hero";
import MissionSection from "./sections/MissionSection";
import CTASection from "../Home/sections/CTASection";
import Values from "./sections/Values";

function About() {
    return (
        <>
            <Hero />
            <MissionSection />
            <Values/>
            <CTASection />
        </>
    );
}

export default About